import { defaultTheme, mergeTheme } from 'evergreen-ui'

// define custom theme params
const customTheme = {
  fontFamilies: { ...defaultTheme.fontFamilies, display: 'Lato', ui: 'Lato' }
}

export const initializeTheme = () => mergeTheme(defaultTheme, customTheme)
